'use client';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import Footer from '../../../components/common/Footer';

const PrivacyPolicy = () => {
    const router = useRouter();
    return (
        <div>
            <Navbar expand="lg" className="">
                <Container>
                    <Navbar.Brand>
                        <Image
                            alt="SQX-logo"
                            src={'/img/SQXBondsColorLogo.webp'}
                            onClick={() => router.push('/')}
                            className="img-fluid cursor-pointer"
                            width={200}
                            height={200}
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                        <Nav className="gap-4">
                            {/* <Nav.Link className='Navmenu-landing-page'><FontAwesomeIcon icon={faHouseChimney} />  Home</Nav.Link> */}
                            {/* <Nav.Link className='Navmenu-landing-page login-button-landing' onClick={() => { navigate('/login') }}><FontAwesomeIcon icon={faRightToBracket} /> Login</Nav.Link> */}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <section className="pb-5">
                <Container>
                    <Row>
                        <Col>
                            <h1>Privacy Policy</h1>
                            <div className="privacy-policy-text">
                                At SQX Bonds we take protection of personal data seriously, and this Privacy Policy is designed to explain
                                how we use any personal information we collect about you when you use this website. For the purpose of the
                                Data Protection legislation in the UK, the Data Controller Exchange Data International Ltd, registered
                                address: <span className='italised'>5 Highgate Road, London NW5 1JY</span>. All of SQX Bonds’s databases, including those holding personal
                                information, are protected by the same technical devices and physical systems and processes. Any personal
                                information that we hold will be held in compliance with UK Data Protection legislation, the EU General Data
                                Protection Regulation and with all other laws concerning the protection of personal information, including
                                the Privacy & Electronic Communications (EC Directive) Regulations 2003. We may update this policy statement
                                from time to time, so please ensure you regularly check back to ensure it is the most current version.
                            </div>
                            <div className="privacy-policy-text">
                                <span className="mt-1 d-block fw-bold">Collection and Use of Personal Information</span>
                                When you:
                                <ul>
                                    <li>Register on our website to receive information about SQX Bonds products and services;</li>
                                    <li>
                                        Submit an enquiry by using our website email link to contact us or by sending us an email or by
                                        logging in to your customer profile; or
                                    </li>
                                    <li>Contact us in other ways, such as over the phone</li>
                                </ul>
                                For product support and related services, the personal information you provide to us, such as your name and
                                contact details, including, but not limited to, your 'work title', your email address, your fixed line and
                                mobile phone numbers - is collected by SQX Bonds. This personal information ("Personal Information") is
                                entitled to specific protections under Data Protection legislation. You are not required to provide Personal
                                Information to us, but, without it, you may have difficulties in accessing our website or services. We also
                                collect information about your use of our site through the use of cookies.
                                <br />
                                <span className="mt-1 d-block fw-bold">How we will use the information we collect</span>
                                The Personal Information we collect is used to respond to your enquiry and/or to provide you with the data
                                products and services which we have contracted to provide to you or to your organisation. We may also
                                provide you from time to time with information about new and existing SQX Bonds products and services.
                                Should you wish that we do not use your Personal Information for these purposes, please notify us at <a href="mailto:data.controller@exchange-data.com">data.controller@exchange-data.com</a> We may also use your site usage information for internal analytics to
                                assist us in improving our products and services to improve our website, understand how you use our site,
                                and provide more relevant content to you. We never sell your Personal Information to any third parties, and
                                you will not receive offers or communications from other companies or organisations as a result of giving
                                your details to us. We will store your Personal Information only for the period required to process your
                                enquiry, or to provide the services that you have requested, or to send you information about our products
                                and services (unless you have notified us that you do not want us to use your Personal Information for these
                                purposes). SQX Bonds does not base any decisions about the personal information you have provided solely on
                                any automated decision-making technology. We do not transfer your Personal Information outside the EEA.
                                Cookies Please view our cookie policy.
                                <br />
                                <span className="mt-1 d-block fw-bold">Other websites</span>
                                This privacy policy only applies to this website so when you link to other websites you should read their
                                own privacy policies.
                                <br />
                                <span className="mt-1 d-block fw-bold">Your rights in relation to your Personal Information</span>
                                Under certain circumstances, you have the right by law to:
                                <ul>
                                    <li>
                                        <span className="fw-semibold">Request access</span> to your Personal Information.
                                    </li>
                                    <li>
                                        <span className="fw-semibold">Request correction</span> of incomplete or inaccurate Personal
                                        Information we hold about you.
                                    </li>
                                    <li>
                                        <span className="fw-semibold">Object to processing</span> of your Personal Information.
                                    </li>
                                    <li>
                                        <span className="fw-semibold">Request the restriction of processing</span> of your Personal
                                        Information.
                                    </li>
                                    <li>
                                        <span className="fw-semibold">Withdraw your consent to the processing</span> of your Personal
                                        Information
                                    </li>
                                </ul>
                                We want to make sure that your personal information is accurate and up to date. You may ask us to correct or
                                remove information that is inaccurate, and you have the right to request to be forgotten by us. You also
                                have the right to request a copy of the information that we hold about you. To exercise any of your rights
                                please contact us in writing to <a href="mailto:data.controller@exchange-data.com">data.controller@exchange-data.com</a>
                                <br />
                                <span className="mt-1 d-block fw-bold">Changes to our privacy policy</span>
                                We keep our privacy policy under regular review and we will place any updates on this web page. This privacy
                                policy was last updated on 23rd March, 2022. For more information, please read our Compliance Statement.
                                <br />
                                <span className="mt-1 d-block fw-bold">How to contact us</span>
                                If you have any concerns or comments about how we use information, we would like to hear from you.
                                Alternatively, you may contact the Information Commissioner’s Office (ICO), the UK supervisory authority for
                                data protection issues for guidance and advice, or to lodge a complaint (<a href='www.ico.org.uk'>www.ico.org.uk</a>).
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Footer />
            </section>
        </div>
    );
};

export default PrivacyPolicy;
